import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AllDatasourcesQuery } from '@y42/datasource';
import { environment } from '@y42/environment';
import { Observable } from 'rxjs';

@Injectable()
export class TriggerApiInterceptor implements HttpInterceptor {
  constructor(private readonly allDatasourcesQuery: AllDatasourcesQuery) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const url =
      req.url.startsWith(environment.url.trigger_api) &&
      !!this.allDatasourcesQuery.getActiveUIModel()?.typeModel.useNewTriggerEndpoint
        ? req.url.replace(environment.url.trigger_api, environment.url.trigger_api_new)
        : req.url;
    return next.handle(req.clone({ url }));
  }
}
